import { PropsWithChildren } from "react";
import { Navigate, Outlet } from "react-router-dom";

interface GuardBaseProps {
  redirectPath: string;
  haveAccess: boolean;
}

type GuardProps = PropsWithChildren<GuardBaseProps>;

export const Guard = ({ children, redirectPath, haveAccess }: GuardProps) => {
  if (!haveAccess) {
    return <Navigate to={redirectPath} replace />;
  }

  // Children cannot be returned directly
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return children ? <>{children}</> : <Outlet />;
};
